import { HttpParams } from '@angular/common/http';

export const getHttpParams = (
  paramObject: Record<string, unknown>,
): HttpParams => {
  let params = new HttpParams();

  for (const [key, value] of Object.entries(paramObject)) {
    if (value !== null && value !== undefined) {
      params = params.set(key, value.toString());
    }
  }
  return params;
};
